import React from 'react';
import { Gem } from 'lucide-react';
import { Switch } from '../../ui/switch';

// Opt-in switch for heavy AI actions: sends the request to Claude Opus 5.5 instead of the normal model.
export const QualityToggle = ({ checked, onChange, testId }) => (
  <label className={`flex items-start gap-3 p-2.5 border text-xs cursor-pointer transition-colors ${checked ? 'border-amber-400 bg-amber-50' : 'border-neutral-200'}`} data-testid={`${testId}-wrap`}>
    <Switch checked={checked} onCheckedChange={onChange} data-testid={testId} className="mt-0.5" />
    <span>
      <span className="font-medium text-neutral-900 inline-flex items-center gap-1"><Gem className="w-3.5 h-3.5 text-amber-600" />Use quality model (Claude Opus 5.5)</span>
      <span className="block text-neutral-500">For complex work. Slower and uses more Universal Key credit.</span>
    </span>
  </label>
);
